const KEY = 'app/settings'

export default{
  KEY
}
